import styled from "styled-components"
import Title from "../../../common/Title"
import Division from "../../../common/Division"
import SkillBox from "../../../common/SkillBox"
import Content from "../../../common/Content"
import Accordion from "../../../common/Accordion"
import ListItem from "../../../common/ListItem"
import ProjectLinkBox from "../../../common/ProjectLinkBox"
import ProjectLink from "../../../common/ProjectLink"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHouse } from "@fortawesome/free-solid-svg-icons"
import { faGithub } from "@fortawesome/free-brands-svg-icons"

const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export default function LyricsBox() {

  return (
    <Box>
      <Title>가사 자막 입력 도우미, LYRICS</Title>
      <Division>개인 프로젝트</Division>
      <SkillBox skill={[
        { logo: 'React', content: '리액트(React)', color: '61DAFB' },
        { logo: 'TypeScript', content: '타입스크립트(TypeScript)', color: '3178C6' },
        { logo: 'redux', content: 'Redux', color: '764ABC' },
        { logo: 'styledcomponents', content: 'Styled-components', color: 'DB7093', division: true },
        { logo: 'firebase', content: 'Firebase Firestore', color: 'FFCA28', division: true },
        { logo: 'firebase', content: 'Firebase Hosting', color: 'FFCA28' },
      ]} />
      <Content>
        <Accordion title="개요" open={true}>
          입력한 가사를 Adobe Premiere Pro에서 이용할 수 있는 SRT 자막 형식으로 변환할 수 있는 기능을 제공하는 엔믹스 팬페이지입니다. 자막변환 페이지에서 가사를 입력하면 자막 파일을 생성·복사·다운로드할 수 있습니다.
        </Accordion>
        <Accordion title="개발 목적" open={true}>
          Premiere Pro로 동영상을 편집하던 중, 노래 가사를 자막으로 넣는 과정이 지나치게 오래 걸린다는 불편함을 느꼈습니다. 더 빠르고 효율적으로 자막을 넣는 방법을 고민하던 끝에, SRT 파일을 활용하면 에디터에서 자막을 손쉽게 생성할 수 있다는 점을 알게 되었습니다.
          이 사실을 바탕으로, 노래 가사를 자동으로 SRT 파일로 변환해 영상 편집에 바로 활용할 수 있도록 기능을 제공하는 사이트를 개발하게 되었습니다.
        </Accordion>
        <Accordion title="주요 기능 및 역할" open={true}>
          <ListItem>가사 변환 및 SRT 파일 다운로드 기능을 제공합니다.</ListItem>
          <ListItem>Firebase Firestore를 활용하여 방문자 수를 집계합니다.</ListItem>
          <ListItem>반응형 디자인으로 데스크톱과 모바일에서 최적화된 화면을 제공합니다.</ListItem>
        </Accordion>
      </Content>
      <ProjectLinkBox>
        <ProjectLink href="https://nmixxfantube-96477.web.app/" title="Home">
          <FontAwesomeIcon icon={faHouse} />
        </ProjectLink>
        <ProjectLink href="https://github.com/Leewonno/lyrics" title="Github">
          <FontAwesomeIcon icon={faGithub} />
        </ProjectLink>
      </ProjectLinkBox>
    </Box>
  )
}

